if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        ZZ.DirectSelect = function(select) {
            var base = this;
            base.select = select;
            base.form = select.parents("form:first");

            base.assignListeners();
        };

        ZZ.DirectSelect.prototype = {
            assignListeners: function() {
                var base = this;
                base.select.on("change", function() {
                    base.form.submit();
                });
            }
        };
    })(jQuery);
}
